module.exports = __webpack_public_path__ + "img/NL557.aaec22b3.png";